import { Helmet } from "react-helmet-async";

const SITE = "https://seedkeepers.com.au";
const DEFAULT_TITLE = "SeedKeepers — expert-led seed systems and restoration infrastructure";
const DEFAULT_DESC =
  "SeedKeepers builds expert-led seed systems, on-Country seed banks, seed production areas and restoration infrastructure across Australia.";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/n6yuc1d8_seedkeepers%20new%20logo.png";

export default function Seo({ title, description, path = "/", image, type = "website" }) {
  const fullTitle = title ? `${title} — SeedKeepers` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMAGE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="SeedKeepers" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
